export default function format_discount(locale, discount) {
  return locale.format_number(discount) + '%';
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/formatDiscount.js
 **/